<template>
    <Card v-if="!error" :loading="loading" overlay content-class="d-flex flex-wrap gap-column-3 child-flex-basis-100">

        <FormValidator form-group :validator="$v.form.name" v-slot="slotProps" :label="$t('name')" label-cols-sm="3">
            <b-form-input v-model="form.name" :state="slotProps.state" :disabled="busy" />
        </FormValidator>
        <FormValidator form-group :validator="$v.form.description" v-slot="slotProps" :label="$t('description')" label-cols-sm="3">
            <b-form-input v-model="form.description" :state="slotProps.state" :disabled="busy" />
        </FormValidator>

        <div class="d-flex gap-3 mt-5">
            <ButtonIcon :loading="saving" :disabled="busy" class="wide" @click="formSubmit()">
                {{ $t('save') }}
            </ButtonIcon>
        </div>

    </Card>
</template>



<script>
    import { required } from 'vuelidate/lib/validators';
    import cloneDeep from 'lodash/cloneDeep';
    import formBackendValidationMixin from '@/mixins/formBackendValidationMixin';
    import { deepMergeWithFilter, scrollToElement } from '@/utils/util';
    import FormValidator from '@/components/common/FormValidator.vue';

    const FORM_DEFAULT_DATA = Object.freeze({
        name: '',
        description: '',
    });

    export default {
        name: 'Form',
        mixins: [formBackendValidationMixin],
        components: {
            FormValidator,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                requestGroups: this.parentComponent.requestGroups,
                requestSpaceGroups: this.$req('producerProductGroups/spaceGroups'),
                form: cloneDeep(FORM_DEFAULT_DATA),
                formValidations: {
                    form: {
                        name: { required },
                        description: {},
                    },
                },
            };
        },
        computed: {
            id() {
                return this.parentComponent.id;
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            loading() {
                return this.request.getLoading();
            },
            error() {
                return this.request.getError();
            },
            saving() {
                return this.request.getLoading('patch') || this.request.getLoading('post');
            },
            busy() {
                return this.loading || this.saving;
            },
            request() {
                return this.id ? this.requestGroups : this.requestSpaceGroups;
            },
            item() {
                return this.parentComponent.item;
            },
        },
        watch: {
            item() {
                this.resetData();
            },
        },
        methods: {
            resetData() {
                this.$v.form.$reset();
                this.initFormData();
            },
            initFormData() {
                this.form = deepMergeWithFilter(FORM_DEFAULT_DATA, this.item);
            },
            sendRequestCreate() {
                const apiParams = {
                    urlParams: { spaceId: this.spaceId },
                    requestParams: this.form,
                };
                return this.requestSpaceGroups.id('post').post(apiParams);
            },
            sendRequestEdit() {
                const apiParams = {
                    urlParams: { id: this.id },
                    requestParams: this.form,
                };
                return this.requestGroups.id('patch').patch(apiParams);
            },
            sendRequest() {
                return this.id ? this.sendRequestEdit() : this.sendRequestCreate();
            },
            async formSubmit() {
                this.$v.form.$touch();
                if (this.$v.form.$invalid) {
                    await this.$nextTick();
                    if (!this.parentComponent.$refs.ModalFormGroup) scrollToElement('.is-invalid', { offset: -80 });
                    return;
                }
                this.sendRequest()
                    .then(async item => {
                        if (this.parentComponent.$refs.ModalFormGroup) {
                            this.parentComponent.$refs.ModalFormGroup.hide();
                            this.resetData();
                        }
                        if (!this.id && this.$route.name === 'ProductGroupsEdit') {
                            await this.$router.push({ params: { id: item.id } });
                        }
                        this.parentComponent.fetchData();
                        this.$toastr.success(this.$t('dataSavedSuccessfully'));
                    })
                    .catch(this.handleBackendValidations);
            },
        },
    };
</script>
